module.exports = __webpack_public_path__ + "img/1489098733.7b04f90d.jpg";